import styled from 'styled-components';

interface ContainerProps {
  scroll?: boolean;
  column?: boolean;
  wide_padding?: boolean;
}
export const Container = styled.main<ContainerProps>`
  max-height: ${({ theme, scroll }) =>
    scroll ? 'auto' : `calc(100vh - ${theme.metrics.header_height} - ${theme.metrics.margin})`};
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  justify-content: ${({ column }) => (column ? 'flex-start' : 'space-between')};
  align-items: stretch;
  padding: ${({ theme }) => theme.metrics.padding};
  gap: ${({ theme }) => theme.metrics.gap};
  background-color: ${({ theme }) => theme.colors.background};
  overflow: ${({ scroll }) => (scroll ? 'auto' : 'hidden')};

  @media (min-width: ${({ theme }) => theme.metrics.desktop_xlarge}) {
    padding: ${({ theme, wide_padding }) => (wide_padding ? '10px 10%' : theme.metrics.padding)};
  }

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    flex-direction: column;
    max-height: initial;
  }

  /* Layout para impressão */
  @media print {
    background-color: #ffffff !important;
    max-height: initial !important;
    display: block;
    overflow: visible;

    button {
      visibility: hidden !important;
      height: 0 !important;
      max-height: 0 !important;
      min-height: 0 !important;
    }

    section {
      display: flex !important;
      margin: 0 !important;
      padding: 0 !important;
      border-radius: 0 !important;
      background-color: transparent !important;
      overflow-x: visible !important;
      page-break-before: auto !important;
      page-break-after: auto !important;
      page-break-inside: avoid !important;
      margin-bottom: 10px !important;

      table {
        border-collapse: collapse !important;
        border-spacing: 1px !important;
        border-radius: 0 !important;
        background-color: transparent !important;
        color: black !important;
        page-break-inside: auto !important;
        page-break-after: auto !important;

        thead {
          background-color: #dfdfdf !important;
          color: black !important;
          
          tr.row-mes-header {
            display: none;
          }

          th {
            background-color: #dfdfdf !important;
            padding: 5px !important;
            border: 1px solid black !important;
            color: black !important;
            font-size: 11px !important;
          }

          th#progesso_carga_horaria {
            display: none;
          }
        }

        tbody {
          tr {
            border: 1px solid black !important;
            background-color: transparent !important;
            background-image: none !important;
            page-break-inside: avoid !important;

            &:nth-child(odd) {
              background-color: transparent !important;
            }

            &.semestre_0 {
              background-color: transparent !important;
            }
            
            &.semestre_1 {
              background-color: rgba(0, 0, 0, 0.05) !important;
            }

            &.semestre_2 {
              background-color: rgba(0, 0, 0, 0.2) !important;
            }

            &.semestre_3 {
              background-color: rgba(0, 0, 0, 0.3) !important;
            }
          }

          td {
            padding: 2px !important;
            font-size: 11px !important;
            background-color: transparent !important;
            color: black !important;
            border: 1px solid black !important;

            &.feriado {
              background-color: ${({ theme }) => theme.colors.error} !important;
            }

            &.progesso_carga_horaria {
              display: none;
            }

            &::before {
              content: none !important;
            }
          }
        }
      }
    }
  }
`;
